import React from 'react';
import { useParams } from 'react-router-dom';
import ListPropertyPage from './ListPropertyPage';

export default function EditListingPage() {
  const { id } = useParams();
  return <ListPropertyPage editId={id} />;
}
